export default __webpack_public_path__ + "static/media/badge_5_soul.92077792.png";